"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectOffers = exports.offersSlice = exports.fetchOffers = exports.default = void 0;
var _toolkit = require("@reduxjs/toolkit");
var _api = require("../api");
const initialState = {
  offers: [],
  pauseOffers: [],
  pauseOffersIDs: [],
  loading: false,
  error: null
};
const fetchOffers = exports.fetchOffers = (0, _toolkit.createAsyncThunk)('offers/fetchOffers', async (arg, _ref) => {
  let {
    rejectWithValue
  } = _ref;
  try {
    const result = await (0, _api.getOffers)();
    return result;
  } catch (err) {
    return rejectWithValue(err.message);
  }
});
const offersSlice = exports.offersSlice = (0, _toolkit.createSlice)({
  name: 'offers',
  initialState,
  extraReducers: {
    [fetchOffers.pending]: state => {
      state.loading = true;
    },
    [fetchOffers.fulfilled]: (state, _ref2) => {
      let {
        payload
      } = _ref2;
      state.loading = false;
      state.offers = payload;
      state.pauseOffers = payload.filter(_ref3 => {
        let {
          externalProperties
        } = _ref3;
        return externalProperties.PAUSE_OFFER === 'true';
      });
      state.pauseOffersIDs = payload.filter(_ref4 => {
        let {
          externalProperties
        } = _ref4;
        return externalProperties.PAUSE_OFFER === 'true';
      }).map(item => item.longId);
    },
    [fetchOffers.rejected]: (state, _ref5) => {
      let {
        payload
      } = _ref5;
      state.loading = false;
      state.error = payload;
    }
  }
});
const selectOffers = state => state.offers;
exports.selectOffers = selectOffers;
var _default = exports.default = offersSlice.reducer;